import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { BookmarkProvider } from './contexts/BookmarkContext';
import Login from './components/Login';
import Register from './components/Register';
import MainLayout from './components/MainLayout';
import BookmarkList from './components/BookmarkList';
import CategoryManagement from './components/CategoryManagement';
import './App.css';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <BookmarkProvider>
        <ThemeProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/category/categories"
              element={
                <PrivateRoute>
                  <MainLayout>
                    <CategoryManagement />
                  </MainLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/category/:categoryId"
              element={
                <PrivateRoute>
                  <MainLayout>
                    <BookmarkList />
                  </MainLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <MainLayout>
                    <BookmarkList />
                  </MainLayout>
                </PrivateRoute>
              }
            />
          </Routes>
        </ThemeProvider>
      </BookmarkProvider>
    </AuthProvider>
  );
}

export default App; 